import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token-storage.service';
const API_URL = environment.apiUrl + 'wallet';
@Injectable({
    providedIn: 'root'
})
export class WalletService {
    authtoken: string;
    private httpOptions;
    constructor(private http: HttpClient, private token: TokenStorageService) {
        this.authtoken = this.token.getToken();
        this.httpOptions = {
            headers: new HttpHeaders()
                .set("Content-Type", "application/json")
                .set('Authorization', `Bearer ${this.authtoken}`)
        };
    }
    getWalletList(query): Observable<any> {
        return this.http.get(API_URL + query,this.httpOptions);
    }
    getWalletDetails(id): Observable<any> {
        return this.http.get(API_URL + '/' + id,this.httpOptions);
    }
    updateWallet(id, userdata): Observable<any> {
        return this.http.put(API_URL + '/' + id, userdata,this.httpOptions);
    }
    addWallet(walletdata): Observable<any> {
        return this.http.post(API_URL, walletdata,this.httpOptions);
    }
}